<kt-portlet>
  <kt-portlet-header [viewLoading$]="loading$" [class]="'card-head-lg'">
    <ng-container ktPortletTitle>
      <h3 class="m-0">{{ getComponentTitle() }}</h3>
    </ng-container>
    <ng-container ktPortletTools>
      <button ktBackButton mat-raised-button class="btn btn-white" (click)="getBackURL($event)">
        {{ 'AUTH.INPUT.BACK' | translate }}
      </button>
      <button mat-raised-button class="btn btn-primary ml-2" (click)="onSumbit()">
        {{ 'AUTH.INPUT.SAVE' | translate }}
      </button>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <mat-tab-group [(selectedIndex)]="selectedTab">
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="mat-tab-label-icon fa fa-info"></i>
          <div class="flex-grow-1 d-flex flex-column align-items-start">
            <span>{{ 'AUTH.INPUT.BASIC_INFO' | translate }}</span>
            <span class="mat-tab-label-desc">User's General Information</span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          <div class="d-flex flex-center">
            <mat-spinner *ngIf="formnotloaded" strokeWidth="5"></mat-spinner>
          </div>
          <kt-alert
            *ngIf="hasFormErrors"
            type="warn"
            [showCloseButton]="true"
            [duration]="10000"
            (closeAl)="onAlertClose($event)"
          >
            {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
          </kt-alert>
          <kt-alert
            *ngIf="hasSubmissionErrors && !hasFormErrors"
            type="warn"
            [duration]="30000"
            [showCloseButton]="true"
            (closeAl)="onAlertClose($event)"
          >
            <ul>
              <li *ngFor="let msg of submissionErrorObj">{{ msg.message | translate }}</li>
            </ul>
          </kt-alert>
          <form *ngIf="user" [formGroup]="userForm">
            <h4 class="mb-10">User's General Information:</h4>
            <div class="row">
              <div class="col-3">
                <div class="image-input image-input-outline image-input-changed">
                  <img id="user_profile" alt="" class="image-input-wrapper" [src]="photoURL" />
                  <label
                    data-action="change"
                    data-original-title="Change avatar"
                    class="mat-fab btn btn-xs btn-icon btn-circle btn-white"
                    (click)="updateProfilePicture()"
                  >
                    <i class="fa fa-pen icon-sm text-muted"></i>
                  </label>
                  <label
                    data-action="remove"
                    data-toggle="tooltip"
                    title="Remove Avatar"
                    class="btn btn-xs btn-icon btn-circle btn-white btn-shadow"
                    (click)="updateProfilePicture()"
                  >
                    <i class="ki ki-bold-close icon-sm text-muted"></i>
                  </label>
                </div>
              </div>
              <div class="col-7">
                <div class="row mb-3" style="max-width: 0 !important; max-height: 0 !important">
                  <input
                    matInput
                    formControlName="username"
                    autocomplete="off"
                    [placeholder]="'USER.INPUT.USERNAME' | translate"
                  />
                  <input
                    matInput
                    type="email"
                    formControlName="email"
                    autocomplete="off"
                    [placeholder]="'USER.INPUT.EMAIL' | translate"
                  />
                  <input
                    matInput
                    type="password"
                    formControlName="password"
                    autocomplete="off"
                    [placeholder]="'USER.INPUT.PASSWORD' | translate"
                  />
                </div>
                <div class="row mb-3">
                  <div class="col-3 input-label">
                    {{ 'USER.INPUT.NAME' | translate
                    }}<span
                      [class.text-danger]="
                        isControlHasError('firstName', 'required') ||
                        isControlHasError('lastName', 'required')
                      "
                      class="ml-1"
                      >*</span
                    >:
                  </div>
                  <div class="col-9 row pr-0">
                    <div class="col-6 pr-0">
                      <mat-form-field appearance="fill">
                        <input
                          matInput
                          formControlName="firstName"
                          [placeholder]="'USER.INPUT.FIRST_NAME' | translate"
                        />
                        <mat-error
                          >{{ 'USER.INPUT.FIRST_NAME' | translate
                          }}{{ 'AUTH.VALIDATION.REQUIRED' | translate }}</mat-error
                        >
                      </mat-form-field>
                    </div>
                    <div class="col-6 pr-0">
                      <mat-form-field appearance="fill">
                        <input
                          matInput
                          formControlName="lastName"
                          [placeholder]="'USER.INPUT.LAST_NAME' | translate"
                        />
                        <mat-error
                          >{{ 'USER.INPUT.LAST_NAME' | translate
                          }}{{ 'AUTH.VALIDATION.REQUIRED' | translate }}</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-3 input-label">
                    {{ 'USER.INPUT.USERNAME' | translate
                    }}<span
                      [class.text-danger]="isControlHasError('stock', 'required')"
                      class="ml-1"
                      >*</span
                    >:
                  </div>
                  <div class="col-9">
                    <mat-form-field appearance="fill">
                      <input
                        matInput
                        formControlName="stock"
                        autocomplete="off"
                        [placeholder]="'USER.INPUT.USERNAME' | translate"
                      />
                      <mat-error
                        >{{ 'USER.INPUT.USERNAME' | translate
                        }}{{ 'AUTH.VALIDATION.REQUIRED' | translate }}</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-3 input-label">
                    {{ 'USER.INPUT.EMAIL' | translate
                    }}<span
                      [class.text-danger]="isControlHasError('userEmail', 'required')"
                      class="ml-1"
                      >*</span
                    >:
                  </div>
                  <div class="col-9">
                    <mat-form-field appearance="fill">
                      <input
                        matInput
                        type="email"
                        formControlName="userEmail"
                        autocomplete="off"
                        [placeholder]="'USER.INPUT.EMAIL' | translate"
                      />
                      <mat-error
                        >{{ 'USER.INPUT.EMAIL' | translate
                        }}{{ 'AUTH.VALIDATION.REQUIRED' | translate }}</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div *ngIf="currentUserRoleType == 'Super Admin' && !user.id" class="row mb-3">
                  <div class="col-3 input-label">
                    {{ 'USER.INPUT.COMPANY' | translate
                    }}<span
                      [class.text-danger]="isControlHasError('company', 'required')"
                      class="ml-1"
                      >*</span
                    >:
                  </div>
                  <div class="col-9">
                    <mat-form-field appearance="fill">
                      <mat-select
                        formControlName="company"
                        [placeholder]="'USER.INPUT.COMPANY' | translate"
                      >
                        <mat-option *ngFor="let company of companies" [value]="company.id">{{
                          company.name
                        }}</mat-option>
                      </mat-select>
                      <mat-error
                        >{{ 'USER.INPUT.COMPANY' | translate
                        }}{{ 'AUTH.VALIDATION.REQUIRED' | translate }}</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div *ngIf="currentUserRoleType != 'Super Admin'" class="row mb-3">
                  <div class="col-3 input-label">
                    {{ 'USER.INPUT.PRIMARY_OFFICE' | translate
                    }}<span
                      [class.text-danger]="isControlHasError('primaryOffice', 'required')"
                      class="ml-1"
                      >*</span
                    >:
                  </div>
                  <div class="col-9">
                    <mat-form-field appearance="fill">
                      <mat-select
                        formControlName="primaryOffice"
                        [placeholder]="'USER.INPUT.PRIMARY_OFFICE' | translate"
                      >
                        <mat-option *ngFor="let office of offices" [value]="office.id">{{
                          office.name
                        }}</mat-option>
                      </mat-select>
                      <mat-error
                        >{{ 'USER.INPUT.PRIMARY_OFFICE' | translate
                        }}{{ 'AUTH.VALIDATION.REQUIRED' | translate }}</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
                <div *ngIf="currentUserRoleType != 'Super Admin'" class="row mb-3">
                  <div class="col-3 input-label">
                    {{ 'USER.INPUT.ALLOWED_OFFICES' | translate }}:
                  </div>
                  <div class="col-9">
                    <mat-form-field appearance="fill">
                      <mat-select
                        formControlName="allowedOffices"
                        multiple
                        [placeholder]="'USER.INPUT.ALLOWED_OFFICES' | translate"
                      >
                        <mat-option *ngFor="let office of offices" [value]="office.id">{{
                          office.name
                        }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div *ngIf="!user.id" class="row mb-3">
                  <div class="col-3 input-label">
                    {{ 'USER.INPUT.PASSWORD' | translate
                    }}<span [class.text-danger]="isControlHasError('pass', 'required')" class="ml-1"
                      >*</span
                    >:
                  </div>
                  <div class="col-9">
                    <mat-form-field appearance="fill">
                      <input
                        matInput
                        type="password"
                        formControlName="pass"
                        autocomplete="off"
                        [placeholder]="'USER.INPUT.PASSWORD' | translate"
                      />
                      <mat-error *ngIf="isControlHasError('pass', 'required')"
                        >{{ 'USER.INPUT.PASSWORD' | translate
                        }}{{ 'AUTH.VALIDATION.REQUIRED' | translate }}</mat-error
                      >
                      <mat-error *ngIf="isControlHasError('pass', 'pattern')">{{
                        'AUTH.VALIDATION.PATTERN_PASSWORD' | translate
                      }}</mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div *ngIf="!user.id" class="row">
                  <div class="col-3 input-label">
                    {{ 'USER.INPUT.CONFIRM_PASSWORD' | translate
                    }}<span
                      [class.text-danger]="isControlHasError('confirmPassword', 'required')"
                      class="ml-1"
                      >*</span
                    >:
                  </div>
                  <div class="col-9">
                    <mat-form-field appearance="fill">
                      <input
                        matInput
                        type="password"
                        formControlName="confirmPassword"
                        autocomplete="off"
                        [placeholder]="'USER.INPUT.CONFIRM_PASSWORD' | translate"
                      />
                      <mat-error *ngIf="isControlHasError('confirmPassword', 'required')"
                        >{{ 'USER.INPUT.CONFIRM_PASSWORD' | translate
                        }}{{ 'AUTH.VALIDATION.REQUIRED' | translate }}</mat-error
                      >
                      <mat-error
                        *ngIf="
                          !isControlHasError('confirmPassword', 'required') &&
                          f.confirmPassword.invalid
                        "
                        >{{ 'AUTH.VALIDATION.NOT_MATCH' | translate }}</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ng-template>
      </mat-tab>
      
      <mat-tab
        *ngIf="currentUserRoleType != 'Super Admin' && formcreated && loggedInUser.id != pathUserId"
      >
        <ng-template mat-tab-label>
          <i class="mat-tab-label-icon fa fa-user-tag"></i>
          <div class="flex-grow-1 d-flex flex-column align-items-start">
            <span>{{ 'USER.INPUT.ROLE' | translate }}</span>
            <span class="mat-tab-label-desc">User's Roles</span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          <kt-alert
            *ngIf="hasFormErrors"
            type="warn"
            [showCloseButton]="true"
            [duration]="10000"
            (closeAl)="onAlertClose($event)"
          >
            {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
          </kt-alert>
          <kt-alert
            *ngIf="hasSubmissionErrors && !hasFormErrors"
            type="warn"
            [duration]="30000"
            [showCloseButton]="true"
            (closeAl)="onAlertClose($event)"
          >
            <ul>
              <li *ngFor="let msg of submissionErrorObj">{{ msg.message | translate }}</li>
            </ul>
          </kt-alert>
          <h4>User's Roles:</h4>
          <kt-user-roles-list [rolesSubject]="rolesSubject"></kt-user-roles-list>
        </ng-template>
      </mat-tab>
      <mat-tab
        *ngIf="
          currentUserRoleType != 'Super Admin' &&
          (pathUserId == currentUserId || currentUserRoleType == 'Admin')
        "
      >
        <ng-template mat-tab-label>
          <div class="d-flex flex-column align-items-start">
            <i class="mat-tab-label-icon multi fa fa-toggle-off"></i>
            <i class="mat-tab-label-icon multi fa fa-toggle-on"></i>
          </div>
          <div class="flex-grow-1 d-flex flex-column align-items-start">
            <span>Activations</span>
            <span class="mat-tab-label-desc">User's Activations</span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          <kt-alert
            *ngIf="hasFormErrors"
            type="warn"
            [showCloseButton]="true"
            [duration]="10000"
            (closeAl)="onAlertClose($event)"
          >
            {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
          </kt-alert>
          <kt-alert
            *ngIf="hasSubmissionErrors && !hasFormErrors"
            type="warn"
            [duration]="30000"
            [showCloseButton]="true"
            (closeAl)="onAlertClose($event)"
          >
            <ul>
              <li *ngFor="let msg of submissionErrorObj">{{ msg.message | translate }}</li>
            </ul>
          </kt-alert>
          <form *ngIf="user" [formGroup]="userForm" class="form">
            <h4 class="mb-10">User's Activations:</h4>
            <div class="row mb-5">
              <div class="col-4 input-label">
                {{ 'USER.INPUT.STATUS' | translate }}: ({{ getStatusString() }})
              </div>
              <div class="col-8">
                <mat-slide-toggle formControlName="isActive"></mat-slide-toggle>
              </div>
            </div>
            <div *ngIf="currentUserRoleType == 'Admin'" class="row mb-5">
              <div class="col-4 input-label">Knostos Engage Agent:</div>
              <div class="col-8">
                <mat-slide-toggle formControlName="isAgent"></mat-slide-toggle>
              </div>
            </div>
          </form>
        </ng-template>
      </mat-tab>
      <mat-tab *ngIf="user && user.id" [disabled]="!user || !user.id">
        <ng-template mat-tab-label>
          <i class="mat-tab-label-icon fa fa-unlock"></i>
          <div class="flex-grow-1 d-flex flex-column align-items-start">
            <span>{{ 'AUTH.INPUT.CHANGE_PASS' | translate }}</span>
            <span class="mat-tab-label-desc">Change User's Password</span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          <kt-alert
            *ngIf="hasFormErrors"
            type="warn"
            [showCloseButton]="true"
            [duration]="10000"
            (closeAl)="onAlertClose($event)"
          >
            {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
          </kt-alert>
          <kt-alert
            *ngIf="hasSubmissionErrors && !hasFormErrors"
            type="warn"
            [duration]="30000"
            [showCloseButton]="true"
            (closeAl)="onAlertClose($event)"
          >
            <ul>
              <li *ngFor="let msg of submissionErrorObj">{{ msg.message | translate }}</li>
            </ul>
          </kt-alert>
          <h4 class="mb-10">Change User's Password:</h4>
          <kt-change-password [userId]="user.id"></kt-change-password>
        </ng-template>
      </mat-tab>
      <mat-tab
        *ngIf="
          currentUserRoleType !== 'Super Admin' && formcreated && loggedInUser.id != pathUserId
        "
      >
        <ng-template mat-tab-label>
          <i class="mat-tab-label-icon fa flaticon-graphic-2"></i>
          Analytics
        </ng-template>
        <ng-template matTabContent>
          <div *ngIf="role" class="row ml-2">
            <label>Rule: {{ role | titlecase }}</label>
          </div>
          <div class="row ml-4"></div>
          <div class="row ml-2">
            <label>Apps:</label>
          </div>
          <div class="ml-3" *ngIf="data?.length === 0"><strong> No Access </strong></div>
          <ul *ngFor="let app of data">
            <li>
              {{ app.name }}
              <ul *ngFor="let pageGroup of app.page_groups">
                <li>
                  {{ pageGroup.name }}
                  <ul *ngFor="let page of pageGroup.pages">
                    <li>{{ page.name }}</li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </kt-portlet-body>
</kt-portlet>
